export default __webpack_public_path__ + "images/79e4898c25304b393e12151d93e3fa02-pyxir.svg";